import objectPath from 'object-path'

export const refreshComponent = async ({ action, data, designContext }) => {
  const { setIsUiChanged, isUiChanged } = designContext
  let { component = [] } = action
  component.forEach((key) => {
    objectPath.set(isUiChanged, ['refreshComponent', key], true)
    setIsUiChanged(isUiChanged)
  })
  return { status: 200 }
}
